<script>
export default {
  functional: true,

  props: {
    isVirtual: { type: Boolean, default: false }
  },

  render(h, { parent, props }) {
    return props.isVirtual
      ? [
          <v-icon icon="airplay" />,
          <span>
            {parent.$t(
              "components.collectionItem.eventOccurrenceFooter.livestreamEvent"
            )}
          </span>
        ]
      : [
          <v-icon icon="place" />,
          <span>
            {parent.$t("components.collectionItem.eventOccurrenceFooter.event")}
          </span>
        ]
  }
}
</script>
